import { defineStore } from 'pinia';

interface GlobalOverlayLoaderStateI {
	archiving: boolean;
	overlayLoaderUUIDArray: string[];
}

const state: GlobalOverlayLoaderStateI = {
	overlayLoaderUUIDArray: [],
	archiving: false,
};

export const useGlobalOverlayLoaderStore = defineStore('globalOverlayLoader', {
	state: () => state,
});
